import { useState } from 'react';
import { useParticipante } from '../../../contexts/ParticipanteContext';
import { Link } from 'react-router-dom';

const ParticipanteCampanhas: React.FC = () => {
  const [filtro, setFiltro] = useState<'todas' | 'ativas' | 'finalizadas'>('ativas');
  const { campanhaAtual, campanhas, confirmarParticipacao } = useParticipante();
  const [showRankingModal, setShowRankingModal] = useState(false);
  const [campanhaRankingSelecionada, setCampanhaRankingSelecionada] = useState<any>(null);
  const [showComparacaoModal, setShowComparacaoModal] = useState(false);
  const [campanhaComparacao, setCampanhaComparacao] = useState<any>(null);
  const [showParticiparModal, setShowParticiparModal] = useState(false);
  const [campanhaParticipacao, setCampanhaParticipacao] = useState<any>(null);
  const [aceitouRegulamento, setAceitouRegulamento] = useState(false);
  const [tokenConfirmacao, setTokenConfirmacao] = useState('');
  const [erroToken, setErroToken] = useState('');
  const [enviandoSolicitacao, setEnviandoSolicitacao] = useState(false);
  const [tokenEnviado, setTokenEnviado] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Usar as campanhas do contexto
  const campanhasFiltradas = campanhas.filter(c => {
    if (filtro === 'todas') return true;
    if (filtro === 'ativas') return c.status === 'ativa' || c.status === 'pendente';
    if (filtro === 'finalizadas') return c.status === 'finalizada';
    return true;
  });

  // Contar campanhas ativas
  const campanhasAtivas = campanhas.filter(c => c.status === 'ativa').length;

  // Calcular estatísticas totais
  const pontosGanhosTotais = campanhas.reduce((acc, c) => acc + (c.pontosGanhos || 0), 0);
  const progressoMedio = campanhas.length > 0 
    ? Math.round(campanhas.reduce((acc, c) => acc + (c.progresso || 0), 0) / campanhas.length)
    : 0;

  const getNivelBadge = (nivel: string) => {
    const badges: Record<string, { icon: string; bg: string; text: string }> = {
      'Diamante': { icon: '💠', bg: 'bg-purple-100', text: 'text-purple-700' },
      'Platina': { icon: '💎', bg: 'bg-cyan-100', text: 'text-cyan-700' },
      'Ouro': { icon: '🥇', bg: 'bg-yellow-100', text: 'text-yellow-700' },
      'Prata': { icon: '🥈', bg: 'bg-slate-200', text: 'text-slate-700' },
      'Bronze': { icon: '🥉', bg: 'bg-orange-100', text: 'text-orange-700' },
    };
    return badges[nivel] || badges['Bronze'];
  };

  const getPosicaoIcon = (posicao: number) => {
    if (posicao === 1) return '🥇';
    if (posicao === 2) return '🥈';
    if (posicao === 3) return '🥉';
    return `#${posicao}`;
  };

  // Função para obter cor do badge de status
  const getStatusBadge = (status: string) => {
    if (status === 'ativa') return { bg: 'bg-green-500', text: 'Ativa' };
    if (status === 'finalizada') return { bg: 'bg-slate-500', text: 'Finalizada' };
    if (status === 'pendente') return { bg: 'bg-yellow-500', text: 'Pendente' };
    return { bg: 'bg-slate-500', text: status };
  };

  // Função para obter cor do tipo
  const getTipoCor = (tipo: string) => {
    const cores: Record<string, string> = {
      'Vendas': 'orange',
      'Performance': 'blue',
      'Fidelização': 'purple',
      'Aquisição': 'teal',
      'Engajamento': 'green'
    };
    return cores[tipo] || 'orange';
  };

  // Calcular dias restantes com countdown visual
  const calcularDiasRestantes = (dataFim: string) => {
    const hoje = new Date();
    const fim = new Date(dataFim);
    const diff = fim.getTime() - hoje.getTime();
    const dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
    const horas = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    return { dias, horas, total: dias };
  };

  // Dados de comparação com período anterior (mock)
  const getComparacaoPeriodoAnterior = (campanha: any) => {
    return {
      periodoAtual: {
        pontos: campanha.pontosGanhos,
        progresso: campanha.progresso,
        posicao: campanha.ranking
      },
      periodoAnterior: {
        pontos: Math.floor(campanha.pontosGanhos * 0.85),
        progresso: Math.floor(campanha.progresso * 0.9),
        posicao: campanha.ranking + 2
      }
    };
  };

  // Função para abrir modal de participação
  const abrirModalParticipacao = (campanha: any) => {
    setCampanhaParticipacao(campanha);
    setShowParticiparModal(true);
    setAceitouRegulamento(false);
    setTokenConfirmacao('');
    setErroToken('');
    setTokenEnviado(false);
  };

  // Função para enviar token por email (simulado)
  const enviarTokenEmail = () => {
    setTokenEnviado(true);
    // Simular envio de email com token
    console.log('Token enviado para o email do participante: 123456');
  };

  // Função para validar e enviar solicitação
  const enviarSolicitacao = () => {
    setErroToken('');
    
    if (!aceitouRegulamento) {
      setErroToken('Você precisa aceitar o regulamento para continuar');
      return;
    }

    if (tokenConfirmacao.length !== 6) {
      setErroToken('O token deve conter 6 dígitos');
      return;
    }

    // Validar token (simulado - em produção validaria com backend)
    if (tokenConfirmacao !== '123456') {
      setErroToken('Token inválido. Verifique o código enviado para seu email');
      return;
    }

    setEnviandoSolicitacao(true);
    
    // Simular envio da solicitação
    setTimeout(() => {
      setEnviandoSolicitacao(false);
      setShowParticiparModal(false);
      setShowSuccessModal(true);

      // Atualizar status da campanha para 'ativa' no contexto
      if (campanhaParticipacao) {
        confirmarParticipacao(campanhaParticipacao.id);
      }

      // Resetar estados
      setAceitouRegulamento(false);
      setTokenEnviado(false);
      setTokenConfirmacao('');
    }, 1500);
  };

  return (
    <div className="space-y-6 pb-20 lg:pb-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Minhas Campanhas</h1>
          <p className="text-sm text-slate-600 mt-1">Acompanhe seu progresso e conquiste suas metas</p>
        </div>
        <div className="flex items-center space-x-2 bg-white rounded-lg p-1 border border-slate-200 shadow-sm">
          {[
            { id: 'todas', label: 'Todas', icon: 'ri-list-check' },
            { id: 'ativas', label: 'Ativas', icon: 'ri-play-circle-line' },
            { id: 'finalizadas', label: 'Finalizadas', icon: 'ri-checkbox-circle-line' }
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => setFiltro(item.id as any)}
              className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all whitespace-nowrap flex items-center gap-2 ${
                filtro === item.id
                  ? 'bg-orange-500 text-white shadow-sm'
                  : 'text-slate-600 hover:text-slate-900'
              }`}
              aria-label={`Filtrar por ${item.label}`}
            >
              <i className={item.icon}></i>
              {item.label}
            </button>
          ))}
        </div>
      </div>

      {/* Estatísticas Rápidas */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
          <div className="flex items-center justify-between mb-3">
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
              <i className="ri-trophy-line text-2xl text-orange-600"></i>
            </div>
          </div>
          <p className="text-2xl font-bold text-slate-900 mb-1">{campanhasAtivas}</p>
          <p className="text-sm text-slate-600">Campanhas Ativas</p>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
          <div className="flex items-center justify-between mb-3">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <i className="ri-coin-line text-2xl text-green-600"></i>
            </div>
          </div>
          <p className="text-2xl font-bold text-slate-900 mb-1">{pontosGanhosTotais.toLocaleString('pt-BR')}</p>
          <p className="text-sm text-slate-600">Pontos Ganhos</p>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
          <div className="flex items-center justify-between mb-3">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <i className="ri-bar-chart-line text-2xl text-purple-600"></i>
            </div>
          </div>
          <p className="text-2xl font-bold text-slate-900 mb-1">{progressoMedio}%</p>
          <p className="text-sm text-slate-600">Progresso Médio</p>
        </div>
      </div>

      {/* Lista de Campanhas */}
      <div className="space-y-6">
        {campanhasFiltradas.map((campanha) => {
          const statusBadge = getStatusBadge(campanha.status);
          const tipoCor = 'orange';
          const { dias, horas } = calcularDiasRestantes(campanha.dataFim);
          const comparacao = getComparacaoPeriodoAnterior(campanha);
          const isPendente = campanha.status === 'pendente';
          
          return (
            <div key={campanha.id} className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-lg transition-all">
              {/* Imagem da Campanha */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={campanha.imagem}
                  alt={campanha.nome}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center justify-between">
                    <span className={`px-3 py-1 rounded-full text-xs font-bold text-white bg-${tipoCor}-500`}>
                      Campanha
                    </span>
                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${statusBadge.bg} text-white`}>
                      {statusBadge.text}
                    </span>
                  </div>
                </div>
              </div>

              {/* Conteúdo */}
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-slate-900 mb-2">{campanha.nome}</h3>
                    <p className="text-sm text-slate-600">{campanha.descricao}</p>
                  </div>
                  {campanha.status === 'ativa' && dias > 0 && (
                    <div className="ml-4 text-center bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-4 border-2 border-orange-200 min-w-[120px]">
                      <div className="flex items-baseline justify-center gap-1 mb-1">
                        <p className="text-3xl font-bold text-orange-600">{dias}</p>
                        <p className="text-sm text-slate-600">dias</p>
                      </div>
                      <p className="text-xs text-slate-500">{horas}h restantes</p>
                      <div className="mt-2 flex items-center justify-center gap-1 text-xs text-orange-600">
                        <i className="ri-time-line animate-pulse"></i>
                        <span className="font-semibold">Expira em breve</span>
                      </div>
                    </div>
                  )}
                </div>

                {/* Progresso - Apenas para campanhas ativas */}
                {!isPendente && (
                  <div className="mb-6">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-semibold text-slate-700">Progresso da Meta</span>
                      <span className="text-sm font-bold text-slate-900">{campanha.progresso}%</span>
                    </div>
                    <div className="h-3 bg-slate-100 rounded-full overflow-hidden">
                      <div
                        className={`h-full bg-gradient-to-r from-${tipoCor}-500 to-${tipoCor}-600 rounded-full transition-all`}
                        style={{ width: `${campanha.progresso}%` }}
                      ></div>
                    </div>
                  </div>
                )}

                {/* Estatísticas - Apenas para campanhas ativas */}
                {!isPendente && (
                  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                    <div className="text-center p-3 bg-slate-50 rounded-lg">
                      <p className="text-lg font-bold text-slate-900">{campanha.pontosGanhos.toLocaleString('pt-BR')}</p>
                      <p className="text-xs text-slate-600">Pontos Ganhos</p>
                    </div>
                    <div className="text-center p-3 bg-slate-50 rounded-lg">
                      <p className="text-lg font-bold text-slate-900">{campanha.pontosDistribuidos.toLocaleString('pt-BR')}</p>
                      <p className="text-xs text-slate-600">Distribuídos</p>
                    </div>
                    <div className="text-center p-3 bg-slate-50 rounded-lg">
                      <p className="text-lg font-bold text-slate-900">{campanha.pontosDisponiveis.toLocaleString('pt-BR')}</p>
                      <p className="text-xs text-slate-600">Disponíveis</p>
                    </div>
                    <div className="text-center p-3 bg-slate-50 rounded-lg">
                      <p className="text-lg font-bold text-slate-900">#{campanha.ranking}</p>
                      <p className="text-xs text-slate-600">Posição</p>
                    </div>
                  </div>
                )}

                {/* Informações Adicionais */}
                <div className="flex flex-wrap items-center gap-4 text-sm text-slate-600 mb-6">
                  <div className="flex items-center space-x-2">
                    <i className="ri-calendar-line"></i>
                    <span>{new Date(campanha.dataInicio).toLocaleDateString('pt-BR')} - {new Date(campanha.dataFim).toLocaleDateString('pt-BR')}</span>
                  </div>
                  {!isPendente && (
                    <div className="flex items-center space-x-2">
                      <i className="ri-group-line"></i>
                      <span>{campanha.totalParticipantes} participantes</span>
                    </div>
                  )}
                </div>

                {/* Ações */}
                {isPendente ? (
                  <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                    <button
                      onClick={() => abrirModalParticipacao(campanha)}
                      className="flex-1 px-6 py-3 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors text-center whitespace-nowrap"
                    >
                      <i className="ri-user-add-line mr-2"></i>
                      Participar
                    </button>
                    <Link
                      to={`/premiado/campanhas/${campanha.id}`}
                      className="px-6 py-3 bg-slate-100 text-slate-700 rounded-lg font-semibold hover:bg-slate-200 transition-colors text-center whitespace-nowrap"
                    >
                      <i className="ri-information-line mr-2"></i>
                      Ver Informações
                    </Link>
                  </div>
                ) : (
                  <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                    <Link
                      to={`/premiado/campanhas/${campanha.id}`}
                      className="flex-1 px-6 py-3 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors text-center whitespace-nowrap"
                    >
                      <i className="ri-eye-line mr-2"></i>
                      Ver Detalhes
                    </Link>
                    <button
                      onClick={() => {
                        setCampanhaRankingSelecionada(campanha);
                        setShowRankingModal(true);
                      }}
                      className="px-6 py-3 bg-slate-100 text-slate-700 rounded-lg font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap"
                      aria-label={`Ver ranking da campanha ${campanha.nome}`}
                    >
                      <i className="ri-bar-chart-line mr-2"></i>
                      Ranking
                    </button>
                    <button
                      onClick={() => {
                        setCampanhaComparacao(campanha);
                        setShowComparacaoModal(true);
                      }}
                      className="px-6 py-3 bg-blue-50 text-blue-700 rounded-lg font-semibold hover:bg-blue-100 transition-colors whitespace-nowrap"
                      aria-label={`Comparar desempenho da campanha ${campanha.nome}`}
                    >
                      <i className="ri-line-chart-line mr-2"></i>
                      Comparar
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {campanhasFiltradas.length === 0 && (
        <div className="text-center py-12">
          <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-trophy-line text-4xl text-slate-400"></i>
          </div>
          <h3 className="text-lg font-bold text-slate-900 mb-2">Nenhuma campanha encontrada</h3>
          <p className="text-sm text-slate-600">Não há campanhas {filtro} no momento.</p>
        </div>
      )}

      {/* Modal de Participação */}
      {showParticiparModal && campanhaParticipacao && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="px-6 py-5 border-b border-slate-200 bg-gradient-to-r from-orange-50 to-white">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
                    <i className="ri-user-add-line text-orange-500"></i>
                    Solicitar Participação
                  </h2>
                  <p className="text-sm text-slate-600 mt-1">{campanhaParticipacao.nome}</p>
                </div>
                <button
                  onClick={() => setShowParticiparModal(false)}
                  className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-slate-100 transition-colors"
                  aria-label="Fechar modal"
                >
                  <i className="ri-close-line text-xl text-slate-600"></i>
                </button>
              </div>
            </div>

            {/* Conteúdo */}
            <div className="flex-1 overflow-y-auto p-6">
              {/* Regulamento */}
              <div className="mb-6">
                <h3 className="text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">
                  <i className="ri-file-text-line text-orange-500"></i>
                  Regulamento da Campanha
                </h3>
                <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 max-h-96 overflow-y-auto">
                  <pre className="text-sm text-slate-700 whitespace-pre-wrap font-sans leading-relaxed">
                    {campanhaParticipacao.regulamento}
                  </pre>
                </div>
              </div>

              {/* Aceite do Regulamento */}
              <div className="mb-6">
                <label className="flex items-start gap-3 cursor-pointer p-4 bg-orange-50 border-2 border-orange-200 rounded-lg hover:bg-orange-100 transition-colors">
                  <input
                    type="checkbox"
                    checked={aceitouRegulamento}
                    onChange={(e) => setAceitouRegulamento(e.target.checked)}
                    className="mt-1 w-5 h-5 text-orange-500 rounded focus:ring-orange-500 cursor-pointer"
                  />
                  <span className="text-sm text-slate-700 flex-1">
                    <strong>Li e aceito o regulamento da campanha.</strong> Estou ciente de todas as regras, condições e requisitos para participation.
                  </span>
                </label>
              </div>

              {/* Token de Confirmação */}
              {aceitouRegulamento && (
                <div className="mb-6">
                  <h3 className="text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <i className="ri-shield-check-line text-orange-500"></i>
                    Confirmação de Participação
                  </h3>
                  
                  {!tokenEnviado ? (
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                      <p className="text-sm text-slate-700 mb-4">
                        Para confirmar sua participação, enviaremos um código de 6 dígitos para seu email cadastrado.
                      </p>
                      <button
                        onClick={enviarTokenEmail}
                        className="w-full px-6 py-3 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-600 transition-colors whitespace-nowrap"
                      >
                        <i className="ri-mail-send-line mr-2"></i>
                        Enviar Código por Email
                      </button>
                    </div>
                  ) : (
                    <div className="space-y-4">
                      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                        <p className="text-sm text-green-800 flex items-center gap-2">
                          <i className="ri-checkbox-circle-line text-lg"></i>
                          Código enviado para seu email! Verifique sua caixa de entrada.
                        </p>
                      </div>
                      
                      <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-2">
                          Digite o código de 6 dígitos:
                        </label>
                        <input
                          type="text"
                          maxLength={6}
                          value={tokenConfirmacao}
                          onChange={(e) => {
                            const valor = e.target.value.replace(/\D/g, '');
                            setTokenConfirmacao(valor);
                            setErroToken('');
                          }}
                          placeholder="000000"
                          className="w-full px-4 py-3 border border-slate-300 rounded-lg text-center text-2xl font-bold tracking-widest focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        />
                        {erroToken && (
                          <p className="mt-2 text-sm text-red-600 flex items-center gap-2">
                            <i className="ri-error-warning-line"></i>
                            {erroToken}
                          </p>
                        )}
                      </div>

                      <button
                        onClick={enviarTokenEmail}
                        className="text-sm text-blue-600 hover:text-blue-700 font-semibold flex items-center gap-2"
                      >
                        <i className="ri-refresh-line"></i>
                        Reenviar código
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-slate-200 bg-slate-50">
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={() => setShowParticiparModal(false)}
                  className="flex-1 px-6 py-3 bg-slate-200 text-slate-700 rounded-lg font-semibold hover:bg-slate-300 transition-colors whitespace-nowrap"
                >
                  Cancelar
                </button>
                <button
                  onClick={enviarSolicitacao}
                  disabled={!aceitouRegulamento || !tokenEnviado || tokenConfirmacao.length !== 6 || enviandoSolicitacao}
                  className="flex-1 px-6 py-3 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors disabled:bg-slate-300 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {enviandoSolicitacao ? (
                    <>
                      <i className="ri-loader-4-line mr-2 animate-spin"></i>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-fill mr-2"></i>
                      Confirmar Participação
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Ranking */}
      {showRankingModal && campanhaRankingSelecionada && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header do Modal */}
            <div className="px-6 py-5 border-b border-slate-200 bg-gradient-to-r from-orange-50 to-white">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
                    <i className="ri-trophy-line text-orange-500"></i>
                    Ranking da Campanha
                  </h2>
                  <p className="text-sm text-slate-600 mt-1">
                    {campanhaRankingSelecionada.nome}
                  </p>
                </div>
                <button
                  onClick={() => setShowRankingModal(false)}
                  className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-slate-100 transition-colors"
                >
                  <i className="ri-close-line text-xl text-slate-600"></i>
                </button>
              </div>
            </div>

            {/* Conteúdo do Modal */}
            <div className="flex-1 overflow-y-auto p-6">
              {/* Top 3 Destaque */}
              <div className="grid grid-cols-3 gap-4 mb-8">
                {campanhaRankingSelecionada.progressao.rankingCompleto.slice(0, 3).map((participante: any) => {
                  const nivelBadge = getNivelBadge(participante.participante.nivel);
                  return (
                    <div
                      key={participante.posicao}
                      className={`text-center p-4 rounded-xl border-2 ${
                        participante.posicao === 1
                          ? 'bg-gradient-to-b from-yellow-50 to-white border-yellow-300'
                          : participante.posicao === 2
                          ? 'bg-gradient-to-b from-slate-50 to-white border-slate-300'
                          : 'bg-gradient-to-b from-orange-50 to-white border-orange-300'
                      }`}
                    >
                      <div className="text-4xl mb-2">{getPosicaoIcon(participante.posicao)}</div>
                      <div className="w-20 h-20 rounded-full mx-auto mb-3 overflow-hidden border-4 border-white shadow-lg">
                        <img
                          src={participante.participante.avatar}
                          alt={participante.participante.nome}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <h3 className="font-bold text-slate-900 mb-1">{participante.participante.nome}</h3>
                      <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold ${nivelBadge.bg} ${nivelBadge.text} mb-2`}>
                        <span>{nivelBadge.icon}</span>
                        <span>{participante.participante.nivel}</span>
                      </div>
                      <div className="text-lg font-bold text-orange-600">
                        {participante.xp.toLocaleString('pt-BR')} XP
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Lista Completa */}
              <div className="space-y-2">
                <h3 className="font-semibold text-slate-900 mb-3 flex items-center gap-2">
                  <i className="ri-list-ordered text-orange-500"></i>
                  Classificação Completa
                </h3>
                {campanhaRankingSelecionada.progressao.rankingCompleto.map((participante: any) => {
                  const nivelBadge = getNivelBadge(participante.participante.nivel);
                  const isCurrentUser = participante.posicao === campanhaRankingSelecionada.ranking;
                  return (
                    <div
                      key={participante.posicao}
                      className={`flex items-center gap-4 p-4 rounded-lg border transition-all ${
                        isCurrentUser
                          ? 'bg-orange-50 border-orange-300 shadow-md'
                          : 'bg-white border-slate-200 hover:border-orange-200 hover:shadow-sm'
                      }`}
                    >
                      {/* Posição */}
                      <div className="w-12 text-center">
                        <span className="text-2xl font-bold text-slate-700">
                          {getPosicaoIcon(participante.posicao)}
                        </span>
                      </div>

                      {/* Avatar */}
                      <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-md flex-shrink-0">
                        <img
                          src={participante.participante.avatar}
                          alt={participante.participante.nome}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>

                      {/* Informações */}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1">
                          <h4 className="font-semibold text-slate-900 truncate">
                            {participante.participante.nome}
                          </h4>
                          {isCurrentUser && (
                            <span className="px-2 py-0.5 bg-orange-500 text-white text-xs font-semibold rounded-full">
                              Você
                            </span>
                          )}
                        </div>
                        <div className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${nivelBadge.bg} ${nivelBadge.text}`}>
                          <span>{nivelBadge.icon}</span>
                          <span>{participante.participante.nivel}</span>
                        </div>
                      </div>

                      {/* XP */}
                      <div className="text-right">
                        <div className="text-xl font-bold text-orange-600">
                          {participante.xp.toLocaleString('pt-BR')}
                        </div>
                        <div className="text-xs text-slate-500">XP</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Footer do Modal */}
            <div className="px-6 py-4 border-t border-slate-200 bg-slate-50">
              <div className="flex items-center justify-between text-sm text-slate-600">
                <div className="flex items-center gap-2">
                  <i className="ri-information-line text-orange-500"></i>
                  <span>Atualizado em tempo real</span>
                </div>
                <button
                  onClick={() => setShowRankingModal(false)}
                  className="px-4 py-2 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Comparação */}
      {showComparacaoModal && campanhaComparacao && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="px-6 py-5 border-b border-slate-200 bg-gradient-to-r from-blue-50 to-white">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
                    <i className="ri-line-chart-line text-blue-600"></i>
                    Comparação de Desempenho
                  </h2>
                  <p className="text-sm text-slate-600 mt-1">{campanhaComparacao.nome}</p>
                </div>
                <button
                  onClick={() => setShowComparacaoModal(false)}
                  className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-slate-100 transition-colors"
                  aria-label="Fechar modal"
                >
                  <i className="ri-close-line text-xl text-slate-600"></i>
                </button>
              </div>
            </div>

            {/* Conteúdo */}
            <div className="flex-1 overflow-y-auto p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Período Atual */}
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border-2 border-green-200">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center">
                      <i className="ri-calendar-check-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-slate-900">Período Atual</h3>
                      <p className="text-sm text-slate-600">Últimos 30 dias</p>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div className="bg-white rounded-lg p-4">
                      <p className="text-sm text-slate-600 mb-1">Pontos Ganhos</p>
                      <p className="text-3xl font-bold text-green-600">
                        {getComparacaoPeriodoAnterior(campanhaComparacao).periodoAtual.pontos.toLocaleString('pt-BR')}
                      </p>
                    </div>

                    <div className="bg-white rounded-lg p-4">
                      <p className="text-sm text-slate-600 mb-1">Progresso</p>
                      <p className="text-3xl font-bold text-green-600">
                        {getComparacaoPeriodoAnterior(campanhaComparacao).periodoAtual.progresso}%
                      </p>
                    </div>

                    <div className="bg-white rounded-lg p-4">
                      <p className="text-sm text-slate-600 mb-1">Posição no Ranking</p>
                      <p className="text-3xl font-bold text-green-600">
                        #{getComparacaoPeriodoAnterior(campanhaComparacao).periodoAtual.posicao}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Período Anterior */}
                <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-6 border-2 border-slate-200">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 bg-slate-500 rounded-lg flex items-center justify-center">
                      <i className="ri-calendar-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-slate-900">Período Anterior</h3>
                      <p className="text-sm text-slate-600">30 dias anteriores</p>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div className="bg-white rounded-lg p-4">
                      <p className="text-sm text-slate-600 mb-1">Pontos Ganhos</p>
                      <p className="text-3xl font-bold text-slate-600">
                        {getComparacaoPeriodoAnterior(campanhaComparacao).periodoAnterior.pontos.toLocaleString('pt-BR')}
                      </p>
                    </div>

                    <div className="bg-white rounded-lg p-4">
                      <p className="text-sm text-slate-600 mb-1">Progresso</p>
                      <p className="text-3xl font-bold text-slate-600">
                        {getComparacaoPeriodoAnterior(campanhaComparacao).periodoAnterior.progresso}%
                      </p>
                    </div>

                    <div className="bg-white rounded-lg p-4">
                      <p className="text-sm text-slate-600 mb-1">Posição no Ranking</p>
                      <p className="text-3xl font-bold text-slate-600">
                        #{getComparacaoPeriodoAnterior(campanhaComparacao).periodoAnterior.posicao}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Análise de Variação */}
              <div className="mt-6 bg-blue-50 border border-blue-200 rounded-xl p-6">
                <h3 className="text-lg font-bold text-slate-900 mb-4 flex items-center gap-2">
                  <i className="ri-pulse-line text-blue-600"></i>
                  Análise de Variação
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-white rounded-lg p-4 text-center">
                    <p className="text-sm text-slate-600 mb-2">Pontos</p>
                    <div className="flex items-center justify-center gap-2">
                      <i className="ri-arrow-up-line text-2xl text-green-600"></i>
                      <p className="text-2xl font-bold text-green-600">+15%</p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg p-4 text-center">
                    <p className="text-sm text-slate-600 mb-2">Progresso</p>
                    <div className="flex items-center justify-center gap-2">
                      <i className="ri-arrow-up-line text-2xl text-green-600"></i>
                      <p className="text-2xl font-bold text-green-600">+10%</p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg p-4 text-center">
                    <p className="text-sm text-slate-600 mb-2">Ranking</p>
                    <div className="flex items-center justify-center gap-2">
                      <i className="ri-arrow-up-line text-2xl text-green-600"></i>
                      <p className="text-2xl font-bold text-green-600">+2 pos</p>
                    </div>
                  </div>
                </div>

                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                  <p className="text-sm text-green-800 flex items-center gap-2">
                    <i className="ri-thumb-up-line text-lg"></i>
                    <strong>Excelente!</strong> Seu desempenho melhorou em relação ao período anterior. Continue assim!
                  </p>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-slate-200 bg-slate-50">
              <button
                onClick={() => setShowComparacaoModal(false)}
                className="w-full px-6 py-3 bg-orange-600 text-white rounded-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Sucesso */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl animate-[scale-in_0.3s_ease-out] overflow-hidden">
            {/* Confetti Animation */}
            <div className="relative bg-gradient-to-br from-orange-500 via-orange-400 to-yellow-400 px-6 py-8 text-center overflow-hidden">
              <div className="absolute inset-0 opacity-20">
                {[...Array(20)].map((_, i) => (
                  <div
                    key={i}
                    className="absolute w-2 h-2 bg-white rounded-full animate-[confetti_2s_ease-out_infinite]"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `-${Math.random() * 20}px`,
                      animationDelay: `${Math.random() * 2}s`,
                    }}
                  />
                ))}
              </div>
              
              <div className="relative">
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg animate-[bounce_1s_ease-in-out_3]">
                  <i className="ri-checkbox-circle-fill text-5xl text-orange-500"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  🎉 Parabéns!
                </h3>
                <p className="text-white/90 text-lg font-medium">
                  Você está participando!
                </p>
              </div>
            </div>

            {/* Content */}
            <div className="px-6 py-6">
              <div className="text-center mb-6">
                <p className="text-slate-700 text-base leading-relaxed mb-4">
                  Sua solicitação foi <span className="font-semibold text-orange-600">confirmada com sucesso</span>! 
                  Agora você faz parte da campanha <span className="font-semibold">{campanhaAtual?.nome}</span>.
                </p>
                
                <div className="bg-gradient-to-r from-orange-50 to-yellow-50 rounded-xl p-4 border border-orange-200">
                  <p className="text-sm text-slate-600 mb-3">
                    <i className="ri-gift-line text-orange-500 mr-2"></i>
                    <span className="font-semibold">Próximos passos:</span>
                  </p>
                  <ul className="text-left text-sm text-slate-600 space-y-2">
                    <li className="flex items-start">
                      <i className="ri-check-line text-orange-500 mr-2 mt-0.5"></i>
                      <span>Acompanhe seu progresso no dashboard</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-orange-500 mr-2 mt-0.5"></i>
                      <span>Complete missões para ganhar pontos extras</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-orange-500 mr-2 mt-0.5"></i>
                      <span>Troque seus pontos por recompensas incríveis</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={() => setShowSuccessModal(false)}
                  className="flex-1 px-6 py-3 bg-slate-100 text-slate-700 rounded-lg font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap"
                >
                  Ver Campanhas
                </button>
                <button
                  onClick={() => {
                    setShowSuccessModal(false);
                    window.REACT_APP_NAVIGATE('/premiado/home');
                  }}
                  className="flex-1 px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
                >
                  <i className="ri-dashboard-line mr-2"></i>
                  Ir para Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParticipanteCampanhas;
